var interactiveTags = ['button', 'a', 'input', 'select', 'textarea'];
export var isInteractiveElement = function isInteractiveElement(element) {
  if (interactiveTags.includes(element.tagName.toLowerCase())) {
    return true;
  }
  if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) {
    return true;
  }
  return false;
};